var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 1020,
    viewBox: "0 0 1020 1020",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1020,
    height: 1020,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.667 367.587C273.667 342.533 283.619 318.505 301.335 300.789C319.051 283.073 343.079 273.12 368.133 273.12H651.533C676.587 273.12 700.615 283.073 718.331 300.789C736.047 318.505 746 342.533 746 367.587V650.987C746 676.041 736.047 700.069 718.331 717.785C700.615 735.501 676.587 745.453 651.533 745.453H368.133C343.079 745.453 319.051 735.501 301.335 717.785C283.619 700.069 273.667 676.041 273.667 650.987V367.587Z",
    fill: "#F7F8F9",
    stroke: "#D0D0D0",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M555.598 538.17C548.347 538.17 541.576 541.632 537.549 547.392L476.12 635.506L458.024 609.574C456.061 606.728 453.388 604.391 450.247 602.772C447.105 601.153 443.592 600.304 440.022 600.299C432.768 600.299 425.996 603.761 421.973 609.521L341.919 724.791C339.741 727.909 338.491 731.533 338.301 735.277C338.112 739.021 338.99 742.743 340.842 746.048C344.568 752.847 359.676 745.267 366.276 745.267H669.935C677.934 745.267 683.976 741.743 687.745 735.011C687.935 738.755 684.888 735.694 687.745 735.011C680.227 724.792 687.745 735.011 680.227 724.792L572.291 547.393C569.696 541.572 562.88 538.17 555.598 538.17ZM420.346 532.253C447.722 532.253 469.923 511.055 469.923 484.917C469.923 458.778 447.768 437.58 420.346 437.58C392.924 437.58 370.769 458.734 370.769 484.917C370.769 511.1 392.924 532.253 420.346 532.253Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.bd195cedbaed21e5944d5ed116085781.svg";
export { ForwardRef as ReactComponent };